class AreaAtuacaoIcmsController extends AbstractController
  @$inject = [ '$injector', 'pathService', 'areaAtuacaoIcmsService']

  constructor: ($injector, pathService, @areaAtuacaoIcmsService) ->
    super($injector)

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/area-atuacao/"
    @loadingTracker = @promiseTracker()
    @modalAreaAtuacao = @openPopup(@url + "modal.html", 'areaAtuacaoIcmsModalController as ctrl', 'lg')

    @filtro = {}

    @listOfAreaAtuacaoIcms = []
    @loadData()

  loadData: () ->
    filtro = angular.copy @filtro

    @loadingTracker.addPromise @areaAtuacaoIcmsService.getList(filtro, (result) =>
      if result.success
        @listOfAreaAtuacaoIcms = result.data.items
      else
        @Alert.error('Ocorreu um erro ao buscar as áreas de atuação.', 'Erro!', false)
    )

  add: ->
    @modalAreaAtuacao({
      areaAtuacaoIcms: => {}
    }, (result) =>
      @loadData())

  edit: (areaAtuacaoIcms) ->
    @modalAreaAtuacao({
      areaAtuacaoIcms: => angular.copy areaAtuacaoIcms
    }, (result) =>
      @loadData())

  remove: (areaAtuacaoIcms)->
    Confirm.warning('Atenção', "Deseja realmente remover a área de atuação ##{areaAtuacaoIcms.id} - #{areaAtuacaoIcms.areaAtuacao.descricao}?", {
      Sim: =>
        @areaAtuacaoIcmsService.delete(areaAtuacaoIcms.id, (result)=>
          if(result.success)
            Alert.success("Área de atuação ##{areaAtuacaoIcms.id} - #{areaAtuacaoIcms.areaAtuacao.descricao} foi removido!.", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover a área de atuação ##{areaAtuacaoIcms.id} - #{areaAtuacaoIcms.areaAtuacao.descricao}.")
        )
      Não: ''
    })

angular.module('eficienciaFiscalModule').controller('areaAtuacaoIcmsController', AreaAtuacaoIcmsController)

class AreaAtuacaoIcmsModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'areaAtuacaoIcmsService', 'areaAtuacaoService', 'aplicacaoService', 'areaAtuacaoIcms' ]

  constructor: ($injector, @modalInstance, @areaAtuacaoIcmsService, @areaAtuacaoService, @aplicacaoService, @areaAtuacaoIcms) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @loadingTracker = @promiseTracker()

    @listOfAplicacao = []
    @listOfAreaAtuacao = []
    @aplicacaoConfig = {padrao: false}
    @areaAtuacaoIcms.aplicacoes ?= []

    @loadingTracker.addPromise @aplicacaoService.getList((data) =>
      @listOfAplicacao = data
    )

    @loadingTracker.addPromise @areaAtuacaoService.getList((result) =>
      @listOfAreaAtuacao = result.data.items
    )

  listOfAplicacoes: () ->
    return @listOfAplicacao if @areaAtuacaoIcms.aplicacoes.length is 0

    @listOfAplicacao.filter( (aplicacao) =>
      not @areaAtuacaoIcms.aplicacoes.some( (config) => config.aplicacao.id == aplicacao.id )
    )

  addAplicacao: () ->
    @areaAtuacaoIcms.aplicacoes.push @aplicacaoConfig
    @aplicacaoConfig = {padrao: false}

  removerAplicacao: (index)->
    if(index > -1)
      @areaAtuacaoIcms.aplicacoes.splice(index, 1)

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @areaAtuacaoIcmsService.save(@areaAtuacaoIcms, (result) =>

        Alert.success("Área de atuação Nº  <strong>#{result.data.id} - #{result.data.areaAtuacao.descricao}</strong> #{if @areaAtuacaoIcms.id then 'atualizada' else 'criada'} com sucesso.", 'Sucesso!')
        @modalInstance.close(new Retorno(true, null, result.data))
      )

angular.module('eficienciaFiscalModule').controller('areaAtuacaoIcmsModalController', AreaAtuacaoIcmsModalController)